export default __webpack_public_path__ + "static/subCh01.2-f96af91fd000667c9f43eabc20982be2.png";